import { IGenericModal, Modal } from 'components/Modal/Modal';
import { TextField } from 'components/_form';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { createPlatformMethodology } from 'api/platformMethodologies';
import { showPlatformApiError } from 'views/PlatformView/platformApiError';

interface Props extends IGenericModal {
  onSuccess: () => void;
}

export const AddPlatformMethodologyForm = ({ isOpen, onCancelClick, onSuccess }: Props) => {
  const { t } = useTranslation();
  const [name, setName] = useState('');

  const handleSave = async () => {
    try {
      await createPlatformMethodology({ methodology: { name: name.trim() } });
      setName('');
      onSuccess();
    } catch (error) {
      showPlatformApiError(error, t);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onCancelClick={onCancelClick}
      headerTitle={t('platformResources.addMethodology')}
      mainButton={{
        action: handleSave,
        variant: 'eucalyptus',
        label: t('buttons.save')
      }}
      isSecondButtonVisible
      gridTemplateColumns="70%"
    >
      <TextField
        label={t('platformResources.fields.name')}
        value={name}
        onChange={(e) => setName(e.target.value)}
        autoFocus
      />
    </Modal>
  );
};
